import { COL_TYPE } from "../DialysisDragDrop.constants";

export function getStyle(table) {
  let repeatColumns = table.length;
  let template = `repeat(${repeatColumns}, 1fr)`;
  if (hasScaleColumn(table)) {
    repeatColumns = repeatColumns - 1;
    template = `43px repeat(${repeatColumns}, 1fr)`;
  }
  return { gridTemplateColumns: template };
}

function hasScaleColumn(table) {
  return table[0].colType === COL_TYPE.SCALE_COLUMN;
}
